import axios from 'axios'
import { ATUALIZAR_CONFIGURACAO_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function atualizarConfiguracaoEmpresa(empresaId, cmd) {
    const url = `${URL}/empresas/${empresaId}/configuracao`;
    return dispatch => axios.put(url, cmd, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: ATUALIZAR_CONFIGURACAO_EMPRESA,
            payload: response
        })
    );
}
